<div [class]="styleClass">
  <div>{{ vehicleAddress.businessName }}</div>
  <div *ngFor="let line of addressLines">
    {{ line }}
  </div>
  <div>{{ vehicleAddress.postcode | postcode }}</div>
</div>
